import {css} from '@emotion/css';

import {colours, spacing} from '../../../styles/js/variables';

const styles = {
  item: css`
    label: currentUserMenu__item;
    display: flex;
    align-items: center;
    margin-bottom: 0.4rem; // stylelint-disable-line sh-waqar/declaration-use-variable
    color: ${colours.font.ASSISTIVE};
    font-weight: normal;
    line-height: 1.5;
    text-decoration: none;

    :hover {
      color: ${colours.font.ASSISTIVE};
      text-decoration: underline;
    }

    :last-child {
      margin-bottom: 0;
    }
  `,
  icon: css`
    label: currentUserMenu__icon;
    // @todo remove important flag once icons are updated to new pattern
    margin-right: ${spacing.XXS} !important;
    // @todo remove margin-left once icons are updated to new pattern
    margin-left: 0 !important;
  `,
};

export default styles;
